import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  fill: "none",
  stroke: "#121212",
  "stroke-width": "4",
  cx: "50",
  cy: "50",
  r: "44",
  style: {"opacity":".5"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  fill: "#ddd",
  stroke: "#121212",
  "stroke-width": "3",
  cx: "8",
  cy: "54",
  r: "6"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeName: "transform",
    dur: "2s",
    type: "rotate",
    from: "0 50 48",
    to: "360 50 52",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      style: _normalizeStyle(`height: ${_ctx.emSize}em; width: ${_ctx.emSize}em;`),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      "xml:space": "preserve"
    }, _hoisted_4, 4))
  ]))
}